import React, { Dispatch, SetStateAction } from 'react'
import usePayAction from 'pages/Wallets/hooks/usePayAction'
import { WalletActions } from 'types/wallets'
import { Pay } from '../Pay/Pay'
import { WalletAction, WalletActionSharedProps } from './WalletModal'

interface WalletModalActionProps {
  action: WalletAction
  walletId: string
  setWalletId: Dispatch<SetStateAction<string>>
  onModalClose: () => void
  refresh: () => void
}

export const WalletModalAction = ({
  action,
  walletId,
  setWalletId,
  onModalClose,
  refresh,
}: WalletModalActionProps) => {
  const actionWalletId = action?.data?.id?.toString()
  const actionKey = action?.key

  const sharedActionProps: WalletActionSharedProps = {
    walletId,
    actionWalletId,
    actionKey,
    setWalletId,
    onModalClose,
  }

  const payActionMeta = {
    beneficiaryOptionId: action?.metadata?.pay?.beneficiaryOptionId,
  }

  const payAction = usePayAction(sharedActionProps, payActionMeta)

  return (
    <>
      {action?.key === WalletActions.PAY && (
        <Pay
          action={action}
          refresh={refresh}
          {...{
            ...payAction,
            isLimitsError: false,
          }}
        />
      )}
    </>
  )
}
